/**
 * useCheckoutDiscount — convenience hook to consume CheckoutDiscountContext.
 *
 * Extracted into its own file so that react-refresh/only-export-components
 * is satisfied: CheckoutDiscountContext.tsx exports only the Provider and
 * interface type, while this file exports only the hook.
 *
 * Usage:
 *   import { useCheckoutDiscountContext } from '@features/discount/context/useCheckoutDiscount';
 *   const { applyingDiscount, discountError, handleApplyDiscount } = useCheckoutDiscountContext();
 */
import { useContext } from 'react';

import CheckoutDiscountContext from './CheckoutDiscountContext';
import type { CheckoutDiscountContextProps } from './CheckoutDiscountContext';

/**
 * Convenience hook to consume CheckoutDiscountContext.
 * Throws if called outside <CheckoutDiscountProvider>.
 */
export const useCheckoutDiscountContext = (): CheckoutDiscountContextProps => {
  const context = useContext(CheckoutDiscountContext);
  if (context === undefined) {
    throw new Error('useCheckoutDiscountContext must be used within a CheckoutDiscountProvider');
  }
  return context;
};
